import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ENV_TOKEN, EnvConfig } from '@clean-code/models/common';
import { SidenavControlsComponent } from '@clean-code/shared/components/ui-sidenav-controls';
import { mintSideNavPanelBackgroundColor } from '@clean-code/shared/util-config';
import { TranslocoModule } from '@jsverse/transloco';
import { animateFade, animateSlide } from '../animations/animations';
import { NavigationComponent } from '../navigation/navigation.component';
import { SideNavService } from '../services/side-nav.service';
import { UserMenuComponent } from '../user-menu/user-menu.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    UserMenuComponent,
    NavigationComponent,
    SidenavControlsComponent,
  ],
  animations: [animateFade, animateSlide],
})
export class SideNavComponent {
  get mintSideNavPanelBackground(): string | null {
    return mintSideNavPanelBackgroundColor(this.env);
  }

  public year: number = new Date().getFullYear();

  constructor(
    @Inject(ENV_TOKEN) public env: EnvConfig,
    public service: SideNavService,
  ) {}
}
